import "./Footer.css";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <a href="#home">
              <span className="logo-text">ABM</span>
              <span className="logo-subtext">Metal Tech</span>
            </a>
            <p>Complete Packaging Solutions</p>
          </div>

          <div className="footer-links">
            <div className="footer-links-column">
              <h3>Quick Links</h3>
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">About Us</a>
                </li>
                <li>
                  <a href="#products">Products</a>
                </li>
                {/* <li>
                  <a href="#industries">Industries</a>
                </li> */}
                <li>
                  <a href="#why-choose-us">Why Choose Us</a>
                </li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h3>Products</h3>
              <ul>
                <li>
                  <a href="#products">All Products</a>
                </li>
                <li>
                  <a href="#products">Easy Open Ends</a>
                </li>
                <li>
                  <a href="#products">Metal Tin Cans/Food Cans</a>
                </li>
                <li>
                  <a href="#products">Plastic Caps</a>
                </li>
                <li>
                  <a href="#products">Slip In Lid</a>
                </li>
                <li>
                  <a href="#products">Plastic Spoons/Measuring Cups</a>
                </li>
                <li>
                  <a href="#products">Ointment Tins</a>
                </li>
                <li>
                  <a href="#products">Peel Off Ends</a>
                </li>
                <li>
                  <a href="#products">Aluminium PP Caps</a>
                </li>
                <li>
                  <a href="#products">Pet Cans</a>
                </li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h3>Resources</h3>
              <ul>
                {/* <li>
                  <a href="#gallery">Gallery</a>
                </li> */}
                <li>
                  <a href="#faq">FAQ</a>
                </li>
                <li>
                  <a href="#blog">Blog</a>
                </li>
                <li>
                  <span className="footer-link-placeholder">Privacy Policy</span>
                </li>
                <li>
                  <span className="footer-link-placeholder">Terms of Service</span>
                </li>
              </ul>
            </div>
            {/* <div className="footer-links-column">
              <h3>Contact</h3>
              <ul className="footer-contact">
                <li>
                  <span className="footer-contact-icon address-icon"></span>
                  123 Industrial Park, Manufacturing District, City, State 12345
                </li>
                <li>
                  <span className="footer-contact-icon phone-icon"></span>
                  +1 (555) 123-4567
                </li>
                <li>
                  <span className="footer-contact-icon email-icon"></span>
                  info@abmmetaltech.com
                </li>
              </ul>
            </div> */}

            <div className="footer-links-column">
              <h3>Contact</h3>
              <ul className="footer-contact">
                <li>
                  <span className="footer-contact-icon">
                    <FaMapMarkerAlt />
                  </span>
                  11, Parmar Industrial Estate, Behind Platinum Hospital & HP
                  Petrol Pump, Vasai East, Mumbai, Maharashtra 401208
                </li>
                <li>
                  <span className="footer-contact-icon">
                    <FaPhoneAlt />
                  </span>
                  <a className="footer-a-links" href="tel:+919822973407">
                    +91 98229 73407
                  </a>
                </li>
                <li>
                  <span className="footer-contact-icon">
                    <FaPhoneAlt />
                  </span>
                  <a className="footer-a-links" href="tel:+919765053894">
                    +91 97650 53894
                  </a>
                </li>
                <li>
                  <span className="footer-contact-icon">
                    <FaEnvelope />
                  </span>
                  <a
                    className="footer-a-links"
                    href="mailto:info@abmmetaltech.com"
                  >
                    info@abmmetaltech.com
                  </a>
                </li>
                <li>
                  <span className="footer-contact-icon">
                    <FaEnvelope />
                  </span>
                  <a
                    className="footer-a-links"
                    href="mailto:abmmetaltech@gmail.com"
                  >
                    abmmetaltech@gmail.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>
              &copy; {new Date().getFullYear()} ABM Metal Tech. All rights
              reserved.
            </p>
          </div>
          {/* <div className="footer-social">
            <a href="#" className="social-icon facebook-icon"></a>
            <a href="#" className="social-icon twitter-icon"></a>
            <a href="#" className="social-icon linkedin-icon"></a>
            <a href="#" className="social-icon instagram-icon"></a>
          </div> */}
          <div className="footer-social">
            <a href="https://www.facebook.com/people/Abm-MetalTech/61553381122486/" className="social-icon" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.youtube.com/@ABMMetaltechIndia" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaYoutube />
            </a>
            <a href="https://www.linkedin.com/in/abmmetaltech/" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaLinkedinIn />
            </a>
            <a href="https://www.instagram.com/abm.metal.tech/" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
